export default "__VITE_ASSET__BVvZqUF2__"